import { render, staticRenderFns } from "./Effect.vue?vue&type=template&id=8aa9d952&scoped=true"
import script from "./Effect.vue?vue&type=script&lang=js"
export * from "./Effect.vue?vue&type=script&lang=js"
import style0 from "./Effect.vue?vue&type=style&index=0&id=8aa9d952&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa9d952",
  null
  
)

export default component.exports